import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export function useOutreach({ company, onClose, onLogged, initialBody }) {
  const [channel, setChannel] = useState("email");
  const [intent, setIntent] = useState("premier_contact");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState(initialBody || "");
  const [to, setTo] = useState(company.email || "");
  const [phone, setPhone] = useState(company.telephone || "");
  const [drafting, setDrafting] = useState(false);
  const [sending, setSending] = useState(false);
  const [mode, setMode] = useState("normal");
  const [exp, setExp] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bb_exp_addr")) || {}; } catch { return {}; }
  });
  const [dest, setDest] = useState({
    societe: company.nom || "", nom: (company.dirigeants && company.dirigeants[0]) || "",
    adresse1: company.adresse || "", cp: company.cp || "", ville: company.ville || "",
  });
  const setExpF = (k, v) => setExp((p) => ({ ...p, [k]: v }));
  const setDestF = (k, v) => setDest((p) => ({ ...p, [k]: v }));

  const draft = async () => {
    setDrafting(true);
    try {
      const { data } = await api.post("/outreach/draft", { company_id: company.id, channel, intent });
      setSubject(data.subject || ""); setBody(data.body || "");
    } catch { toast.error("Erreur génération IA"); } finally { setDrafting(false); }
  };

  const sendEmail = async () => {
    if (!to.trim()) return toast.error("Renseignez l'email du destinataire");
    setSending(true);
    try {
      await api.post("/outreach/email", { company_id: company.id, to, subject, body });
      toast.success("Email envoyé");
      onLogged?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Échec de l'envoi"); } finally { setSending(false); }
  };

  const sendWhatsapp = async () => {
    if (!phone.trim()) return toast.error("Renseignez le numéro WhatsApp");
    const digits = phone.replace(/[^0-9]/g, "");
    window.open(`https://wa.me/${digits}?text=${encodeURIComponent(body)}`, "_blank");
    try { await api.post("/outreach/whatsapp-log", { company_id: company.id, body }); onLogged?.(); } catch (e) { console.debug("whatsapp log failed", e); }
    toast.success("WhatsApp ouvert");
  };

  const downloadPdf = async () => {
    setSending(true);
    try {
      const res = await api.post("/outreach/letter-pdf", { company_id: company.id, subject, body }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `courrier_${company.nom}.pdf`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Courrier PDF généré");
      onLogged?.();
    } catch { toast.error("Erreur génération PDF"); } finally { setSending(false); }
  };

  const sendPostal = async () => {
    if (!exp.nom || !exp.cp || !exp.ville) return toast.error("Complétez votre adresse d'expéditeur (nom, CP, ville).");
    if (!dest.cp || !dest.ville || !(dest.nom || dest.societe)) return toast.error("Complétez l'adresse du destinataire (nom/société, CP, ville).");
    localStorage.setItem("bb_exp_addr", JSON.stringify(exp));
    setSending(true);
    try {
      await api.post("/outreach/postal", { company_id: company.id, subject, body, mode, exp, dest });
      toast.success("Courrier envoyé via Merci Facteur");
      onLogged?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Envoi postal indisponible"); }
    finally { setSending(false); }
  };

  return {
    channel, setChannel, intent, setIntent, subject, setSubject, body, setBody,
    to, setTo, phone, setPhone, drafting, sending, mode, setMode,
    exp, dest, setExpF, setDestF,
    draft, sendEmail, sendWhatsapp, downloadPdf, sendPostal,
  };
}
